export * from './ConsentPlaceholder';
